<div class="row margin-bottom-20">
	<div fxFlex fxLayoutGap="5px">
		<button id="PAY_CATEGORY_ADD" mat-raised-button color="primary" (click)="navigate('0', 'new')">
			Create New Pay Category
		</button>
		<div fxFlex></div>
		<mat-checkbox
			name="onlyArchived"
			id="ARCHIVED_PAY_CATEGORIES_TOGGLE"
			[(ngModel)]="onlyArchived"
			(ngModelChange)="changeFilter()"
		>
			<small>Archived</small>
		</mat-checkbox>
	</div>
</div>
<div>
	<div *ngIf="!onlyArchived" class="row my-2">
		<h3 id="ACTIVE_PAY_CATEGORIES_TITLE">Active Categories</h3>
	</div>

	<div *ngIf="onlyArchived" class="row">
		<h3 id="ARCHIVED_PAY_CATEGORIES_TITLE">Archived Categories</h3>
	</div>

	<div
		*ngIf="!isLoading && (activePayCategories || futurePayCategories || archivedPayCategories)"
		fxLayout="row"
		fxLayoutAlign="center center"
	>
		<mat-form-field class="input-full-width">
			<input matInput type="text" placeholder="Filter by name or short code" [(ngModel)]="searchText" />
			<button
				mat-button
				*ngIf="searchText"
				matSuffix
				mat-icon-button
				aria-label="Clear"
				(click)="searchText = ''"
			>
				<mat-icon>close</mat-icon>
			</button>
		</mat-form-field>
	</div>

	<div fxLayout="row wrap" *ngIf="!onlyArchived">
		<div *ngIf="!activePayCategories || !activePayCategories.length">
			<app-dump-card [isLoading]="isLoading" [categoryType]="'active'"></app-dump-card>
		</div>

		<div
			fxFlex.sm="100%"
			fxFlex.xs="100"
			fxFlex.md="33.33%"
			fxFlex.lg="33.33%"
			fxFlex.xl="33.33%"
			fxFlex="100%"
			*ngFor="let payCategory of activePayCategories | filter: searchText:'name':'shortCode'; let i = index"
		>
			<app-category-card
				[payCategory]="payCategory"
				[onlyArchived]="onlyArchived"
				[idPrefix]="'ACTIVE_PAY_CATEGORY_' + i"
			></app-category-card>
		</div>
	</div>

	<div *ngIf="!onlyArchived" class="row  my-2 ml-1">
		<h3 id="FUTURE_PAY_CATEGORIES_TITLE">Future Categories</h3>
	</div>

	<div fxLayout="row wrap" *ngIf="!onlyArchived">
		<div *ngIf="!futurePayCategories || !futurePayCategories.length">
			<app-dump-card [isLoading]="isLoading" [categoryType]="'future'"></app-dump-card>
		</div>
		<div
			fxFlex.sm="100%"
			fxFlex.xs="100"
			fxFlex.md="33.33%"
			fxFlex.lg="33.33%"
			fxFlex.xl="33.33%"
			fxFlex="100%"
			*ngFor="let payCategory of futurePayCategories; let i = index"
		>
			<app-category-card
				[payCategory]="payCategory"
				[onlyArchived]="onlyArchived"
				[idPrefix]="'FUTURE_PAY_CATEGORY_' + i"
			></app-category-card>
		</div>
	</div>

	<div fxLayout="row wrap" *ngIf="onlyArchived">
		<div *ngIf="!archivedPayCategories || !archivedPayCategories.length">
			<app-dump-card [isLoading]="isLoading" [categoryType]="'archived'"></app-dump-card>
		</div>
		<div
			fxFlex.sm="100%"
			fxFlex.xs="100"
			fxFlex.md="33.33%"
			fxFlex.lg="33.33%"
			fxFlex.xl="33.33%"
			fxFlex="100%"
			*ngFor="let payCategory of archivedPayCategories; let i = index"
		>
			<app-category-card
				[payCategory]="payCategory"
				[onlyArchived]="onlyArchived"
				[idPrefix]="'ARCHIVED_PAY_CATEGORY_' + i"
			></app-category-card>
		</div>
	</div>
</div>
